import { render, staticRenderFns } from "./TalentCardPreview.vue?vue&type=template&id=2dab170e&scoped=true&"
import script from "./TalentCardPreview.vue?vue&type=script&lang=js&"
export * from "./TalentCardPreview.vue?vue&type=script&lang=js&"
import style0 from "./TalentCardPreview.vue?vue&type=style&index=0&id=2dab170e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dab170e",
  null
  
)

export default component.exports